import { Button, Input, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import AddIcon from "../../../assets/icons/AddIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import AddCategoryModal from "../../../components/Product/AddCategoryModal";
import EditCategoryModal from "../../../components/Product/EditCategoryModal";
import CustomTable from "../../../components/ui/CustomTable";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../utils/number";
import { addKeyInArray } from "../../../utils/utils";

enum Status {
  Active = "Active",
  Inactive = "Inactive",
}

export default function ProductCategories() {
  const { open, handleOpen, handleClose } = useModal();
  const { page, limit, handlePagination, handleLimit } = useTable();

  const columns: ColumnsType<LeaveDataType> = [
    {
      title: "#SL",
      dataIndex: "index",
      align: "center",
      width: 50,
      render: (_: any, __: any, index: number) =>
        countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Category Name",
      dataIndex: "name",
    },
    {
      title: "Created at",
      dataIndex: "date",
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (value: keyof typeof Status) => (
        <span
          className={`${
            value === "Active" ? "status-success" : "status-danger"
          }`}
        >
          {value}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "key",
      align: "center",
      render: (val) => (
        <Space size={8}>
          <Button
            icon={<EditIcon />}
            size="small"
            className="action-button"
            onClick={() =>
              handleOpen({
                type: "UPDATE",
                data: val,
              })
            }
          />
          {/* <Button
            icon={<DeleteIcon />}
            size="small"
            className="action-button"
            danger
          /> */}
        </Space>
      ),
    },
  ];

  return (
    <SidebarLayout title="Products">
      {open.type === "ADD" && (
        <AddCategoryModal
          open={open.open}
          type={open.type}
          data={open.data}
          handleClose={handleClose}
        />
      )}
      {open.type === "UPDATE" && (
        <EditCategoryModal
          open={open.open}
          type={open.type}
          data={open.data}
          handleClose={handleClose}
        />
      )}
      <CustomTable
        loading={false}
        limit={limit}
        page={page}
        columns={columns}
        total={100}
        dataSource={addKeyInArray(data)}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input suffix={<SearchIcon />} placeholder="Search" />

            <Button
              className="middle-button"
              type="primary"
              icon={<AddIcon />}
              onClick={() =>
                handleOpen({
                  type: "ADD",
                })
              }
            >
              Add Category
            </Button>
          </>
        }
      />
    </SidebarLayout>
  );
}

interface LeaveDataType {
  key: string;
  name: string;
  date: string;
  status: string;
}

const data: LeaveDataType[] = [
  {
    key: "1",
    name: "Package - 1",
    date: "10 Jan, 2025",
    status: "Active",
  },
  {
    key: "2",
    name: "Package - 2",
    date: "10 Jan, 2025",
    status: "Inactive",
  },
];
